var module = angular.module('octopusApp.environments');
var machineImages = require.context('../../../img/machines', true);

module.controller('MachineDiscoverController', function ($scope, busy, octopusRepository, $location, endpoints) {
  var isLoading = $scope.isLoading = busy.create();
  var isDiscovering = $scope.isDiscovering = busy.create();

  var endpointModule = function() {
    var self = this;

    this.communicationStyle = null;
    this.host = null;
    this.port = null;

    this.canDiscover = function() {
      return endpoints.canDiscover(self.communicationStyle);
    };
    this.isListeningTentacle = function() {
      return endpoints.isListeningTentacle(self.communicationStyle);
    };
    this.isPollingTentacle = function() {
      return endpoints.isPollingTentacle(self.communicationStyle);
    };
    this.defaultPort = function() {
      return endpoints.getDefaultPort(self.communicationStyle);
    };
  };

  $scope.endpoint = new endpointModule();

  $scope.view = {};
  $scope.view.machineUseProxy = !!$scope.endpoint.ProxyId;

  $scope.machineImages = machineImages;
  $scope.communicationStyles = endpoints.communicationStyles;
  $scope.environmentId = $location.$$search["environment"];

  isLoading.promise(octopusRepository.Proxies.list().then(function (proxies) {
    $scope.proxies = proxies.Items;
  }));

  isLoading.promise(octopusRepository.Alerts.list().then(function(alerts) {
    $scope.alerts = alerts;
  }));

  isLoading.promise(octopusRepository.CertificateConfiguration.getOctopusCertificate().then(function(certificate) {
    $scope.serverThumbprint = certificate.Thumbprint;
  }));

  $scope.discover = function () {
    var addMachineUrl = "/machines/new/manual?environment=" + $scope.environmentId + "&type=" + $scope.endpoint.communicationStyle;

    if ($scope.endpoint.canDiscover()) {
      isDiscovering.promise(octopusRepository.Machines.discover($scope.endpoint.host, $scope.endpoint.port, $scope.endpoint.communicationStyle, $scope.endpoint.ProxyId).then(function(discovered) {

        function str(x) {
          return x || "";
        }

        if (discovered.Endpoint.CommunicationStyle === "TentaclePassive") {
          addMachineUrl += (
                "&uri=" + str(discovered.Endpoint.Uri)
              + "&host=" + str(discovered.Endpoint.Host)
              + "&port=" + str(discovered.Endpoint.Port)
              + "&thumbprint=" + str(discovered.Endpoint.Thumbprint)
              + "&proxyId=" + str($scope.endpoint.ProxyId)
          );
        } else if (discovered.Endpoint.CommunicationStyle === "Ssh") {
          addMachineUrl += (
                "&uri=" + str(discovered.Endpoint.Uri)
              + "&host=" + str(discovered.Endpoint.Host)
              + "&port=" + str(discovered.Endpoint.Port)
              + "&fingerprint=" + str(discovered.Endpoint.Fingerprint)
          );
        }
        $location.url(addMachineUrl);
      }));
    } else {
      $location.url(addMachineUrl);
    }
  };

  $scope.useProxyChanged = function(){
    if(!$scope.view.machineUseProxy){
      $scope.endpoint.ProxyId = null;
    }
  };

});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/controllers/environment_discover_machine_controller.js
// module id = 686425632676366
// module chunks = 1